import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Retourne un statut détaillé du backend pour permettre au front d'afficher
// un message adapté à la cause réelle de l'indisponibilité.
//   - 'ok'           : backend joignable et OK
//   - 'rate_limited' : backend joignable mais a renvoyé 429
//   - 'down'         : backend injoignable (timeout, DNS, refus de connexion, 5xx…)
export const checkBackendHealth = async () => {
  try {
    // Timeout de 3 secondes pour éviter de bloquer trop longtemps
    const response = await axios.get(`${API_URL}/api/health-check`, {
      timeout: 3000
    });
    return response.status === 200 ? 'ok' : 'down';
  } catch (error) {
    if (error.response?.status === 429) {
      return 'rate_limited';
    }
    console.error('Erreur de connexion au backend:', error);
    return 'down';
  }
};